import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <CommentsSection />
        <FeaturesSection />
        <ContactSection />
        <MediaSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}